import React from 'react';

import Item from '../Item/Item';
import styles from './styles.module.scss';

const ItemList = (props) => {
    const { data } = props;

    return (
        <>
            {data.map((item, index) => {
                const { title, Icon, pathTo, onClick, unreadMessages, isNeedUser } = item;

                return (
                    <div key={`${title}_${index}`} className={styles.item}>
                        <Item
                            Icon={Icon}
                            title={title}
                            pathTo={pathTo}
                            onClick={onClick}
                            unreadMessages={unreadMessages}
                            isNeedUser={isNeedUser}
                        />
                    </div>
                );
            })}
        </>
    );
};

export default ItemList;
